export default __webpack_public_path__ + "static/media/Ballroll_00176.7aa30649.png";